import { render, staticRenderFns } from "./contentTitle.vue?vue&type=template&id=b4c8ce22&scoped=true&"
import script from "./contentTitle.vue?vue&type=script&lang=js&"
export * from "./contentTitle.vue?vue&type=script&lang=js&"
import style0 from "./contentTitle.vue?vue&type=style&index=0&id=b4c8ce22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c8ce22",
  null
  
)

export default component.exports